import { render, staticRenderFns } from "./PrfTraceabilityEur.vue?vue&type=template&id=5c5e02fe"
import script from "./PrfTraceabilityEur.vue?vue&type=script&lang=js"
export * from "./PrfTraceabilityEur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports